import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GalleryCardComponent from "../../../app/src/Components/common/GalleryCardComponent";
import { IMAGE_HEIGHT, IMAGE_HEIGHT_MOBILE, IMAGE_WIDTH, IMAGE_WIDTH_MOBILE } from "../../CatalogueConstants";
import { URL_VIDEODETAIL } from "../../../app/src/Components/Routes/Location";
import { generateSlug } from "../../../app/src/Utils/utils";
import keycloak from "../../../app/src/Utils/keycloak";

const ContentCardComponent = ({ content, imageCard }) => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 480;
  const slug = content.title ? generateSlug(content.title) : null;
  const pathname = URL_VIDEODETAIL + "/" + content.id + (slug ? "/" + slug : "");

  return (
    <div className="PlaylistItemContainer VideoContainer" key={content.id}>
      <Link to={{ pathname }}>
        <GalleryCardComponent
          image={imageCard}
          width={isMobile ? IMAGE_WIDTH_MOBILE : IMAGE_WIDTH}
          height={isMobile ? IMAGE_HEIGHT_MOBILE : IMAGE_HEIGHT}
          contentType={content.type?.name}
          tags={content.tags}
        />
      </Link>
      <div className="contentFooter">
        <div className="PlaylistItemTitle-Default">{content.title}</div>
        <div className="PlayFavContainer">
          <div className="boton-play">
            <Link className="BotonVer" to={{ pathname }}>
              {t("ficha.seeDetail")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentCardComponent;
